import React from 'react'
import { LayoutDashboard } from 'lucide-react'

export default function Main() {
  return (
    <div className="space-y-6">
      <div className="card">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-lg bg-primary-100 text-primary-600">
            <LayoutDashboard className="w-6 h-6" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900">메인</h2>
        </div>
        <p className="text-gray-600">
          EXPLAT Agent 메인 화면입니다. 에이전트용 페이지는 추후 추가할 예정입니다.
        </p>
      </div>
    </div>
  )
}
